// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"47f3d8de","322":"e11cec09","440":"0ef7def5","533":"90dae3f9","766":"47f3d8de"}[chunkId] + ".chunk.css";
};